module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jL2Ut"))).then(() => parcelRequire('1iHdE'));